import React from 'react';
import { FiAward } from 'react-icons/fi';
import { Button } from '@/components/ui/button';

export function LearningPathCompletion({ onGenerateNew }) {
  return (
    <div
      role="status"
      style={{ animation: 'trilha-in 420ms cubic-bezier(0.23, 1, 0.32, 1) both' }}
      className="mx-auto mt-8 w-full max-w-md rounded-3xl border border-neutral-100 bg-white p-10 text-center shadow-card"
    >
      <div className="relative mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-3xl bg-mission-light">
        <FiAward
          className="h-10 w-10 text-mission"
          strokeWidth={2.2}
        />
        <span className="absolute -right-1.5 -top-1.5 text-2xl">✨</span>
      </div>

      <h2 className="text-2xl font-extrabold text-neutral-900">Parabéns! 🎉</h2>
      <p className="mx-auto mt-2 max-w-xs text-[15px] leading-relaxed text-neutral-500">Você percorreu todos os blocos desta trilha. Pronto para o próximo desafio?</p>

      <Button
        type="button"
        variant="mission"
        fullWidth
        className="mt-7"
        onClick={onGenerateNew}
      >
        Gerar nova trilha
      </Button>
    </div>
  );
}
